<div class="modal__wrapper">
  <div class="modal__title">
    {{ 'HOMEPAGE.contact_form' | translate }}
  </div>
  <div class="modal__description">
    {{ 'HOMEPAGE.contact_form_desc' | translate }}
  </div>
  <app-ph-input
    [placeholder]="'HOMEPAGE.contact_email' | translate"
    [validation]="'contactemail'"
    type="email"
    [showRequired]="true"
    [initValue]="storage.user ? storage.user.email : ''"
    name="email"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    [placeholder]="'HOMEPAGE.contact_topic' | translate"
    [validation]="'contacttopic'"
    type="text"
    [showRequired]="true"
    name="title"
    [correctForm]="form"
  ></app-ph-input>
  <app-ph-input
    [placeholder]="'HOMEPAGE.contact_message' | translate"
    [validation]="'contactmessage'"
    type="textarea"
    [showRequired]="true"
    name="message"
    [correctForm]="form"
  ></app-ph-input>
  <ngx-recaptcha2
    #captchaElem
    [siteKey]="recaptchaSiteKey"
    (success)="handleSuccessRecaptcha($event)"
    (error)="errorRecaptcha($event)"
  >
  </ngx-recaptcha2>
  <div class="modal__actions modal__actions--multiple">
    <button class="btn btn--outline btn--default btn--md mw-160" (click)="closeModal()">
      {{ 'HOMEPAGE.contact_close' | translate }}
    </button>
    <button
      class="btn btn--primary btn--md mw-160"
      [disabled]="form.invalid || loading || !captchaValid"
      (click)="submitContactForm(false)"
    >
      {{ 'HOMEPAGE.contact_send' | translate }}
    </button>
  </div>
</div>
